// extracted by mini-css-extract-plugin
export var growableInput = "_8d-0";
export var tagContainer = "_8d-2";
export var textInput = "_8d-1";